export enum TextType {
  Normal = 0,
  Bold = 1,
  Italic = 2,
}

export const getRandomColor = () => {
  return "#" + Math.floor(Math.random() * 16777215).toString(16);
};
